module.exports = __webpack_public_path__ + "static/media/location_icon.4b40b1c7.svg";